<div class="row">
  <div class="col-md-12" *ngIf="showAllowedEmployees">
    <table class="table">
      <tr>
        <th></th>
        <th></th>
        <th></th>
      </tr>
      <tr class="employee-table" *ngFor="let item of employeesArrayList.allowed; let i = index;">
        <td>{{ i + 1 }}</td>
        <td>{{ item.employee_name }}</td>
        <td>{{ item.employee_number }}</td>
      </tr>
    </table>
  </div>
  <div class="col-md-12" *ngIf="!showAllowedEmployees">
    <table class="table">
      <tr>
        <th></th>
        <th></th>
        <th></th>
      </tr>
      <tr class="employee-table" *ngFor="let item of employeesArrayList.notAllowed; let i = index;">
        <td>{{ i + 1 }}</td>
        <td>{{ item }}</td>
      </tr>
    </table>
  </div>
</div>
